<template>
  <div>
    <div v-if="data.validUntil !== null" class="asd-warning">
      <i class="fas fa-trash"></i> Tento zdroj byl vyhozen do koše
    </div>
    <div class="asd-form-section heading-section">
      <h1>
        <ContextMenu
          :items="[
            {icon: 'fa-trash', label: 'Smazat zdroj', action: disableResource},
            {icon: 'fa-trash-restore', label: 'Aktivovat zdroj', action: enableResource},
          ]"
        >
          <template #icon>
            <i class="fas fa-bars"></i>
          </template>
        </ContextMenu>
        {{ resourceLabel }}
      </h1>
    </div>
    <div class="asd-form-section">
      <div class="section-title">
        <h5>
          <i class="fas fa-grip-horizontal"></i>
          Vlastnosti
        </h5>
        <!-- <div v-if="data.validUntil === null" class="section-title-controls">
          <button v-if="editProperties" class="asd-btn-confirm" @click="save()">
            <i class="fas fa-save"></i>
          </button>
        </div> -->
      </div>
      <ResourceForm
        :resourceId="resourceId"
      >
      </ResourceForm>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import labels from 'CORE/utils/labels'
import ContextMenu from 'CORE/components/context-menu'
import ResourceDataMixin from 'CORE/mixins/resource-data'
import ResourceForm from './form'

export default {
    name: 'ResourceDetail',
    components: {
        ContextMenu,
        ResourceForm,
    },
    mixins: [
        ResourceDataMixin,
    ],
    props: {
        resourceId: {
            type: String,
            required: false,
            default: _ => null,
        },
    },
    data() {
        return {
            data: {},
            editProperties: false,
            showDeleteProjectModal: false,
            taskTypeFilter: null,
            taskListType: 'table', // table or tree
        }
    },
    computed: {
        resourceLabel() {
            return labels.resource(this.data)
        },
        // filesSettings() {
        //     return _.get(this.$store.getters.settings, 'modules.files', {})
        // },
        // filesBaseFolder() {
        //     return _.get(this.project, `propertyValues.${this.filesSettings.baseFolderProperty}.value.value`, null)
        // },
        // filesBasePropName() {
        //     return _.lowerCase(_.get(this.$store.getters.propertyTypeByKey(this.filesSettings.baseFolderProperty), 'name', ''))
        // },
        // projectPropertyKeys() {
        //     return _.map(_.get(this.projectType, 'propertyType', {}), pt => pt.key)
        // },
        // projectTaskTypes() {
        //     return _.map(this.$store.getters.taskTypesByProjectId(this.projectId), typeId => {
        //         return {
        //             id: _.get(this.$store.getters.taskTypeById(typeId), 'id'),
        //             name: _.get(this.$store.getters.taskTypeById(typeId), 'name'),
        //         }
        //     })
        // },
        // tasksRootFilter() {
        //     if (this.taskTypeFilter === null) {
        //         return null
        //     } else {
        //         const taskName = _.get(this.$store.getters.taskTypeById(this.taskTypeFilter), 'name', null)
        //         return { _projectType: taskName }
        //     }
        // },
    },
    created() {
        this.data = this.$store.getters.resourceById(this.resourceId)
        console.assert(
            _.isString(_.get(this.data, 'id')),
            'Invalid ID after data creation (not existing Project or invalid UUID creation)'
        )
    },
    methods: {
        async disableResource() {
            try {
                await this.$prompt('Opravdu chcete zdroj smazat?')
                await this.$store.dispatch('disableResource', this.data.id)
                await this.$store.dispatch('resourcesLoad')
                this.flash('Zdroj byl přesunut do koše.', 'success', {
                    timeout: 5000,
                })
                this.$emit('done')
            } catch (e) {
                this.flash(`Chyba ${e}`, 'danger')
            } finally {
                this.showDeleteProjectModal = false
            }
        },
        async enableResource() {
            try {
                await this.$prompt('Opravdu chcete zdroj znovu aktivovat?')
                await this.$store.dispatch('enableResource', this.data.id)
                await this.$store.dispatch('resourcesLoad')
                this.flash('Zdroj byl reaktivován!.', 'success', {
                    timeout: 5000,
                })
                this.$emit('done')
            } catch (e) {
                this.flash(`Chyba ${e}`, 'danger')
            } finally {
                this.showDeleteProjectModal = false
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.asd-tabs {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid var(--color-primary);
    & > * {
        white-space: nowrap;
        padding: 3px 10px;
        margin-right: 5px;
        border-top-right-radius: 3px;
        border-top-left-radius: 3px;
        border-top: 1px solid;
        border-left: 1px solid;
        border-right: 1px solid;
        background-color: whitesmoke;
        border-color: lightgray;
        cursor: pointer;
    }
    & > *.active {
        border-color: var(--color-input-border);
        background-color: white;
        border-bottom: 1px solid white;
        transform: translateY(1px);
        z-index: 10;
    }
}

.asd-warning {
    color: black;
    background: repeating-linear-gradient(135deg, rgba(231, 55, 39, 0) 0px, rgba(231, 55, 39, 0) 9px, rgba(231, 55, 39, 0.7) 10px, rgba(231, 55, 39, 0.7) 19px);
    font-size: 2rem;
    font-weight: bold;
    padding: 30px;
    text-align: center;
}
</style>
